// Shared constants for employer onboarding
export const steps = ["Company Information", "Team member", "Job description", "Requirements"];

// Language options for dropdown
export const languages = [
    "English",
    "Afrikaans",
    "Zulu",
    "Xhosa",
    "French",
    "German",
    "Spanish",
    "Portuguese",
    "Arabic",
    "Mandarin",
    "Hindi",
    "Swahili",
    "Yoruba",
    "Igbo",
    "Hausa",
    "Italian",
    "Dutch",
    "Russian",
    "Japanese",
    "Korean",
    "Turkish",
    "Polish",
    "Greek",
    "Hebrew",
    "Urdu",
    "Bengali",
    "Tamil",
    "Telugu",
    "Marathi",
    "Gujarati",
    "Punjabi",
    "Malayalam",
    "Kannada",
    "Odia",
    "Assamese",
    "Nepali",
    "Sinhala",
    "Thai",
    "Vietnamese",
    "Indonesian",
    "Malay",
    "Tagalog",
    "Filipino",
    "Swedish",
    "Norwegian",
    "Danish",
    "Finnish",
    "Czech",
    "Hungarian",
    "Romanian",
    "Bulgarian",
    "Croatian",
    "Serbian",
    "Slovak",
    "Slovenian",
    "Lithuanian",
    "Latvian",
    "Estonian",
    "Ukrainian",
    "Persian",
    "Pashto",
    "Kurdish",
    "Amharic",
    "Somali",
    "Fulani",
    "Wolof",
    "Kinyarwanda",
    "Luganda",
    "Setswana",
    "Sesotho",
    "Tswana",
    "Venda",
    "Tsonga",
    "Ndebele",
    "Swati",
    "Northern Sotho",
    "Southern Sotho"
];

